import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable import/no-named-as-default */
import { useState, useEffect, useLayoutEffect, useContext, useCallback, useRef } from 'react';
import getThreshold from './getThreshold';
import ResponsiveContext from './ResponsiveContext';
import defaultThresholdMap from './defaultThresholdMap';

// React currently throws a warning when using useLayoutEffect on the server.To get
//   around it, we can conditionally useEffect on the server (no-op) and
//   useLayoutEffect in the browser.
var useEnhancedEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;
function useThreshold() {
  var responsiveContext = useContext(ResponsiveContext);
  var nextAnimationFrame = useRef(null);
  var map = responsiveContext ? responsiveContext.getThresholdMap() : defaultThresholdMap;
  var _useState = useState(function () {
      return getThreshold(0, map);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    threshold = _useState2[0],
    setThreshold = _useState2[1];
  var getCurrentThreshold = useCallback(function () {
    return getThreshold(window.innerWidth, map);
  }, [map]);
  useEnhancedEffect(function () {
    setThreshold(getCurrentThreshold());
  }, []);
  useEffect(function () {
    var updateThreshold = function updateThreshold() {
      var newThreshold = getCurrentThreshold();
      if (threshold !== newThreshold) {
        setThreshold(newThreshold);
      }
    };
    var handleResize = function handleResize() {
      if (!nextAnimationFrame.current) {
        nextAnimationFrame.current = window.requestAnimationFrame(function () {
          nextAnimationFrame.current = null;
          updateThreshold();
        });
      }
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
      window.cancelAnimationFrame(nextAnimationFrame.current);
    };
  }, [map, threshold, getCurrentThreshold]);
  return threshold;
}
export default useThreshold;